export default "__VITE_ASSET__k1swNJ2a__"